import {
  OnDestroy
} from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { DialogWrapperComponent } from './dialog-wrapper.component';
import { DialogService } from './dialog.service';
import { Router } from '@angular/router';

/**
 * Abstract dialog
 * @template T - dialog data;
 * @template T1 - dialog result
 */
export class DialogComponent<T, T1> implements OnDestroy {

  /**
   * Observer to return result from dialog
   */
  private observer: Observer<T1>;

  /**
   * Dialog result
   * @type {T1}
   */
  protected result: T1;

  /**
   * Dialog wrapper (modal placeholder)
   */
  wrapper: DialogWrapperComponent;
  IsCollapsed: boolean = false;
  Context: String;
  Subscriptions: Array<any> = new Array<any>();

  /**
   * Constructor
   * @param {DialogService} dialogService - instance of DialogService
   */
  constructor(protected dialogService: DialogService, protected router: Router) {
    this.Context = router.url;
  }

  /**
   *
   * @param {T} data
   * @return {Observable<T1>}
   */
  fillData(data: T): Observable<T1> {
    data = data || <T>{};
    let keys = Object.keys(data);
    for (let i = 0, length = keys.length; i < length; i++) {
      let key = keys[i];
      this[key] = data[key];
    }
    return Observable.create((observer) => {
      this.observer = observer;
      return () => {
        this.close();
      };
    });
  }

  /**
   * Closes dialog
   */
  close(): void {
    this.Subscriptions.forEach((observable) => {
      observable.unsubscribe();
    });
    this.dialogService.removeDialog(this);
  }

  collapse(): boolean {
    this.IsCollapsed = !this.IsCollapsed;
    return this.IsCollapsed;
  }

  GoToContext() {
    if (this.Context) {
      this.router.navigate([this.Context.toString()]);
    }
  }

  /**
   * OnDestroy handler
   * Sends dialog result to observer
   */
  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.next(this.result);
    }
  }
}
